export default __webpack_public_path__ + "df622aedccd65948e25d0fe0eca4e525.svg";